"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var ColoredItemContent_1 = tslib_1.__importDefault(require("./ColoredItemContent"));
var ColorDropdown_1 = tslib_1.__importDefault(require("../colorDropdown/ColorDropdown"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ColoredItem = /** @class */ (function (_super) {
    tslib_1.__extends(ColoredItem, _super);
    function ColoredItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onColorSelected = function (color) {
            var _a = _this.props, item = _a.item, onSelect = _a.onSelect;
            if (onSelect) {
                onSelect(item, color);
            }
        };
        return _this;
    }
    ColoredItem.prototype.render = function () {
        var coloredItem = this.props.item ? this.props.item : null;
        if (!coloredItem) {
            return this.renderLoadingItem();
        }
        var headerItem = coloredItem.mappingHeader;
        var text = this.getText(headerItem);
        return (react_1.default.createElement(ColorDropdown_1.default, { selectedColorItem: coloredItem.colorItem, colorPalette: this.props.colorPalette, onColorSelected: this.onColorSelected, showCustomPicker: this.props.showCustomPicker },
            react_1.default.createElement(ColoredItemContent_1.default, { text: text, color: coloredItem.color })));
    };
    ColoredItem.prototype.renderLoadingItem = function () {
        return react_1.default.createElement("div", { className: "gd-list-item gd-list-item-not-loaded" });
    };
    ColoredItem.prototype.getText = function (mappingHeader) {
        return sdk_ui_1.getMappingHeaderName(mappingHeader) || "";
    };
    ColoredItem.defaultProps = {
        showCustomPicker: false,
        disabled: false,
    };
    return ColoredItem;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(ColoredItem);
//# sourceMappingURL=ColoredItem.js.map